import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useAdmin = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["admin-info", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;

      const { data, error } = await supabase
        .from("profiles")
        .select("full_name, email")
        .eq("id", user.id)
        .single();

      if (error) {
        console.error("Error fetching admin info:", error);
        return null;
      }

      return {
        name: data?.full_name || null,
        email: data?.email || null,
      };
    },
    enabled: !!user?.id,
  });
};
